import initialState from "../../../Client/redux/reducers/initialState";
import { LiveSwitchAction } from "../../../LiveSwitch/liveSwitchActions";
import { ExternalObserverSessionInfo } from "../../../Shared/GeneratedTypes";
import * as types from "../actions/actionTypes";
import { CurrentMentorsActions } from "../actions/currentClientActions";

export default function externalObserverReducer(
    state: ExternalObserverSessionInfo[] | null = initialState.externalObservers,
    action: CurrentMentorsActions | LiveSwitchAction
): ExternalObserverSessionInfo[] | null {
    switch (action.type) {
        case types.HEARTBEAT_COMPLETE:
            return action.heartBeatResult.externalObservers;
    }

    return state;
}
